import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';

import { Bar } from 'react-chartjs-2';
import pluralize from 'pluralize';

export default class BarChart extends React.Component {
  static propTypes = {
    graphData: PropTypes.object,
    legendData: PropTypes.arrayOf(PropTypes.shape({
      color: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired
    })),
    preview: PropTypes.bool
  }

  sampleData() {
    return this.props.graphData.datasets[0].data;
  }

  minUnit() {
    const dataSetSample = this.sampleData();
    const startDate = moment(dataSetSample[0].x);
    const endDate = moment(dataSetSample[dataSetSample.length - 1].x);

    if (endDate.diff(startDate, 'days') > 186) return 'month';

    return 'day';
  }

  graphOptions = () => {
    const categoryPercentage = this.props.preview ? 0.6 : 0.4;
    const tickSource = this.sampleData().length > 15 ? 'auto' : 'data';

    return {
      maintainAspectRatio: false,
      legend: { display: false },
      scales: {
        xAxes: [{
          categoryPercentage,
          barPercentage: 1.0,
          barThickness: 'flex',
          type: 'time',
          distribution: 'series',
          offset: true,
          gridLines: { display: false, offset: false },
          ticks: { source: tickSource },
          time: {
            minUnit: this.minUnit(),
            tooltipFormat: 'MMM D'
          }
        }],
        yAxes: [{
          gridLines: { display: false, offset: false },
          ticks: { beginAtZero: true }
        }]
      }
    };
  }

  renderLegend() {
    const { legendData } = this.props;
    if (legendData) {
      const className = this.props.preview ? '' : 'h4 bold';
      return (
        <div className={`${className} bottom-buffer-md text-center`} name="legend">
          {legendData.map((data, i) => (
            <span className={`${i < legendData.length ? 'mr-4' : ''}`} key={data.label}>
              <FontAwesomeIcon className="right-buffer-sm" color={data.color} icon={faCircle} size="xs" />
              {pluralize(data.label, data.count, true)}
            </span>
          ))}
        </div>
      );
    }
  }

  render() {
    const height = this.props.preview ? 260 : 400;
    return (
      <React.Fragment>
        {this.renderLegend()}
        <div className="bar-chart">
          <Bar data={this.props.graphData} height={height} maintainAspectRatio={false} options={this.graphOptions()} />
        </div>
      </React.Fragment>
    );
  }
}
